export default __webpack_public_path__ + "static/media/posto.51349e78.svg";